import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Circle from "ol/style/Circle";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import { StyleFunction } from "ol/style/Style";
import Style from "ol/style/Style";

const getRoutingLayer = () => {
  const routingStyle: StyleFunction = (feature) => {
    const mot = feature.get("mot");
    const viaPointIdx = feature.get("viaPointIdx");

    // Default style for route lines
    const stroke =
      mot &&
      new Stroke({
        color: [255, 0, 0, 1],
        lineDash: mot === "foot" ? [1, 10] : undefined,
        width: 3,
      });

    // Default style for via points
    const image =
      viaPointIdx !== undefined &&
      new Circle({
        fill: new Fill({
          color: [255, 0, 0, 1],
        }),
        radius: 6,
        stroke: new Stroke({
          color: [0, 0, 0, 1],
          width: 1,
        }),
      });

    const style = new Style({
      image,
      stroke,
    });

    return style;
  };

  const routingLayer = new VectorLayer({
    source: new VectorSource(),
    style: routingStyle,
    zIndex: 1000,
  });
  return routingLayer;
};
export default getRoutingLayer;
